
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registerpartner",
      function () {
        return require("private-next-pages/registerpartner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registerpartner"])
      });
    }
  